import createUseNav from "@subly/s1/core/hooks/useNav";
import router from "router";


export default createUseNav<typeof router>();